<template>
	<div class="leftres">
		<!-- <div> -->
		<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
			<div style="display: inline-block;" v-for="(item , index) of formdata" :key="index+'from'">
				<Commondropdownlist ref="wareref" :inputflag="item.inputflag" :event="item.event" @invClass="invClass"
					@remoteMethodtows="remoteMethodtows" :key="index" :options="item.options" :minrigth="item.minrigth"
					:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
					:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
					:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types"
					:inputtype="item.inputtype" :width="item.width">
				</Commondropdownlist>
			</div>
			<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
				<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
					@reset="reset">
				</CommonBtngroup>
			</div>
			<div style="height:10px;">
			</div>
		</div>
		<div class="TableBox"
			style=" margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
			<Warehousingreportmanagementcenter @update="update" @Expost="Expost" @onRowClick="onRowClick" :type="type"
				:tableData="tableData" :tableDatas="tableDatas" :total="total"
				@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
			</Warehousingreportmanagementcenter>
		</div>
		<div class="TableBox"
			style="margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
			<Warehousingreportmanagementbottom :tableDataUnique="tableDataUnique" :tableDataDetail="tableDataDetail"
				@clicktab="clicktab" :asnmid="asnmid" :state="state"></Warehousingreportmanagementbottom>
		</div>
		<!-- </div> -->

	</div>

</template>

<script>
	import Warehousingreportmanagementcenter from './components/warehousingreportmanagementcenter.vue'
	import Warehousingreportmanagementbottom from './components/warehousingreportmanagementbottom.vue'
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import utils from '../../../common/utils'
	import {
		AsnList,
		ASNVoucherType,
		Status,
		InventoryClassList,
		AsnExpost,
		CusType,
		InventoryClassInfo,
		AsnDetail,
		AsnUnique,
	} from '@/api/home'
	export default {
		components: {
			Warehousingreportmanagementcenter,
			Warehousingreportmanagementbottom,
			Commondropdownlist,
			CommonBtngroup
		},
		data: function() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				inoutbot: true,
				showorhide: true,
				state: [{
						title: '明细'
					},
					{
						title: '唯一码'
					}
				],
				type: null,
				wtype: null,
				formdata: [{
						inputdata: '',
						title: '经销商单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '95px',
						options: [],
						inputflag: false,
					},
					{
						inputdata: "",
						title: "入库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '75px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '80px',
						options: [],
						event: "invClass",
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						lablewith: '95px',
						options: []
					},
					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '220px',
						lablewith: '95px',
						options: [

						]
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: '75px'
					},


					{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '95px'
					},

				],
				type: 0,
				CusTypeFlag: 0,
				asnmid: '',
				form: {
					vouCode: '',
					cusName: '',
					createTime1: '',
					createTime2: '',
					invClass: '',
					status: null,
					voucherType: '',
					VerifyTime1: '',
					VerifyTime2: '',
					InvAddCode: '',
					InvName: '',
					Batch: ''
				},
				loading: true,
				tableDatas: [],
				tableDataDetail: [],
				tableDataUnique: [],

			}
		},
		mounted() {
			this.onchage = 0
			this.cusType()
			this.aSNVoucherType()
			this.status()
			this.inventoryClassList()
			this.asnList()
		},
		methods: {

			// 唯一码明细 
			async asnUnique() {
				let {
					data,
					code
				} = await AsnUnique({
					asnmid: this.asnmid
				})
				if (code == 0) {
					this.tableDataUnique = data
				}
			},

			// 导出接口
			async asnExpost() {
				let resexprot = await AsnExpost({
					vouCode: this.form.vouCode,
					cusName: this.form.cusName,
					createTime1: this.form.createTime1,
					createTime2: this.form.createTime2,
					invClass: this.form.invClass,
					status: this.form.status,
					voucherType: this.form.voucherType,
					VerifyTime1: this.form.VerifyTime1,
					VerifyTime2: this.form.VerifyTime2,
					InvAddCode: this.form.InvAddCode,
					InvName: this.form.InvName,
					Batch: this.form.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {

					// 切割出文件名
					// const fileNameEncode = resexprot.headers.get('content-disposition').split('filename=')[1]
					// // 解码
					// const fileName = decodeURIComponent(fileNameEncode)
					//console.log(resexprot.headers);
					// //console.log('fileName', fileName)

					utils.downloadFile(resexprot.data, `入库单导出${new Date().getTime()}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}

			},
			// 导出
			Expost() {
				this.asnExpost()
			},
			onRowClick(val) {
				this.asnmid = val.ASNMID
				this.asnUnique()
				this.asnDetail()
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[3].options.push(obj)
					})
				}
			},
			// 单据类型下拉
			async aSNVoucherType() {
				let {
					code,
					data
				} = await ASNVoucherType({})
				if (code == 0) {
					this.formdata[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[5].options.push(obj)
					})

				}

			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[4].options.push(obj)
					})

				}

			},
			// 列表
			async asnList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await AsnList({
					vouCode: this.form.vouCode,
					cusName: this.form.cusName,
					createTime1: this.form.createTime1,
					createTime2: this.form.createTime2,
					invClass: this.form.invClass,
					status: this.form.status,
					voucherType: this.form.voucherType,
					VerifyTime1: this.form.VerifyTime1,
					VerifyTime2: this.form.VerifyTime2,
					InvAddCode: this.form.InvAddCode,
					InvName: this.form.InvName,
					Batch: this.form.Batch,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
				loading.close();
			},
			async cusType() {
				let {
					code,
					data
				} = await CusType({
					// hpName: query
				})
				if (code == 0) {
					if (data.CusType == "") {
						this.CusTypeFlag = 1
						this.formdata[1].inputflag = true
					} else if (data.CusType == "平台") {
						this.CusTypeFlag = 2
						this.formdata[1].inputflag = false
					} else {
						this.CusTypeFlag = 3
						this.formdata[1].inputflag = false
					}
				}
			},
			// 经销商名称远程搜索下拉
			async remoteMethodtows(query) {
				// this.loading = true
				// let {
				//   code,
				//   data
				// } = await CusType({
				//   // hpName: query
				// })
				// if (code == 0) {
				//   this.formdata[1].options = []
				//   let obj = {
				//     key: data.CusCode,
				//     value: data.CusType
				//   }
				//   this.formdata[1].options.push(obj)
				//   this.loading = false
				// }
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.asnList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.asnList()
			},
			hide() {
				this.showorhide = false
			},
			// async inventoryClassInfo(invClass) {
			//   let {
			//     code,
			//     data
			//   } = await InventoryClassInfo({
			//     invClass: invClass
			//   })
			//   if (code == 0) {
			//     if (data.IsBarCodeControl == 1) {
			//       let arr = [{
			//         title: '明细'
			//       },
			//       {
			//         title: '唯一码'
			//       }
			//       ]
			//       this.wtype = 1
			//       this.state = arr
			//     } else if (data.IsBarCodeControl == 0) {
			//       let arr = [{
			//         title: '明细'
			//       }
			//       ]
			//       this.wtype = 0
			//       this.state = arr
			//     }
			//   }
			// },
			invClass(e) {

			},
			// 唯一码明细
			async asnUnique() {
				let {
					data,
					code
				} = await AsnUnique({
					asnmid: this.asnmid
				})
				if (code == 0) {
					this.tableDataUnique = data
					this.tableDatas = data
				}
			},

			// 明细
			async asnDetail() {
				let {
					data,
					code
				} = await AsnDetail({
					asnmid: this.asnmid
				})
				if (code == 0) {
					this.tableDataDetail = data
					this.tableDatas = data
				}
			},
			update() {
				if (this.type == 0) {
					this.asnDetail()
				}
				if (this.type == 1) {
					this.asnUnique()
				}
			},
			clicktab(index) {
				this.type = index
				//console.log(index, 'index');
			},
			showclick() {
				this.showorhide = true
			},
			// 搜索
			select() {
				this.pageindex = 1
				const wareRef = this.$refs.wareref || []
				const voucherTypeValue = wareRef[5] && Array.isArray(wareRef[5].modelvalue) ? wareRef[5].modelvalue : []
				this.form.vouCode = wareRef[0] ? wareRef[0].modelvalue : ''
				this.form.cusName = wareRef[1] ? wareRef[1].modelvalue : ''
				this.form.createTime1 = wareRef[2] ? wareRef[2].startTime : ''
				this.form.createTime2 = wareRef[2] ? wareRef[2].endTime : ''
				this.form.invClass = wareRef[3] ? wareRef[3].modelvalue : ''
				this.form.status = wareRef[4] ? wareRef[4].modelvalue : null
				this.form.voucherType = voucherTypeValue.join(',')
				this.form.VerifyTime1 = wareRef[6] ? wareRef[6].startTime : ''
				this.form.VerifyTime2 = wareRef[6] ? wareRef[6].endTime : ''
				this.form.InvAddCode = wareRef[7] ? wareRef[7].modelvalue : ''
				this.form.InvName = wareRef[8] ? wareRef[8].modelvalue : ''
				this.form.Batch = wareRef[9] ? wareRef[9].modelvalue : ''
				this.asnList()

			},
			// 重置
			reset() {
				;(this.$refs.wareref || []).forEach((item, index) => {
					if (!item) return
					if (index == 2 || index == 6) {
						item.startTime = ''
						item.endTime = ''
						return
					}
					const inputtype = this.formdata[index] && this.formdata[index].inputtype
					item.modelvalue = inputtype === 'selectMultiple' ? [] : ''
				})
				this.form = {
					vouCode: '',
					cusName: '',
					createTime1: '',
					createTime2: '',
					invClass: '',
					status: null,
					voucherType: '',
					VerifyTime1: '',
					VerifyTime2: '',
					InvAddCode: '',
					InvName: '',
					Batch: ''
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.avcite {
		border-left: 4px solid #e71d43;
		background-color: #fce8ec;
		color: #e71d43;
	}

	.leftres {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.inputtop {
		width: 980px;
		height: 100px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 273px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 95px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>
